import styled from "styled-components";
import { List } from "@material-ui/core";

export const STContainerMenuList = styled(List)`
  && {
    height: calc(100vh - 64px);
    display: flex;
    flex-direction: column;
    overflow: auto;
  }
`;
